var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeepMinelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 80,
    viewBox: "0 0 136 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.7483 45.5386H83.7505V30.1535H87.7483L92.5389 38.6513L97.3295 30.1535H101.328V45.5386H97.3295V37.6576L93.8831 43.9967H91.1602L87.7138 37.6576V45.5386H87.7483Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.98 45.5386H102.913V30.1535H106.98V45.5386Z",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.46 45.5386H108.565V30.1535H112.184L118.733 38.5827V30.1535H122.662V45.5386H119.009L112.46 37.1436V45.5386Z",
    fill: "#D6D6D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.213 30.1535H132.864L135.966 33.8884H128.28V35.9101H134.587V39.645H128.28V41.8037H136V45.5044H124.213V30.1535Z",
    fill: "#D6D6D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5762 39.3366H25.8834V35.6017H19.5762V33.5801H27.2275V29.8452H15.5093V45.196H27.2964V41.4954H19.5762V39.3366Z",
    fill: "#D6D6D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6731 39.3366H38.9803V35.6017H32.6731V33.5801H40.3244V29.8452H28.6062V45.196H40.4278V41.4954H32.6731V39.3366Z",
    fill: "#D6D6D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9733 31.353C51.8359 30.325 50.4573 29.811 48.8374 29.811H41.7375V45.1962H45.8045V40.5704H48.8374C50.4573 40.5704 51.8359 40.0564 52.9733 39.0284C54.1106 38.0004 54.662 36.6984 54.662 35.1907C54.662 33.683 54.1106 32.3809 52.9733 31.353ZM49.9747 36.39C49.6645 36.6984 49.2854 36.8697 48.8374 36.8697H45.8045V33.5459H48.8374C49.2854 33.5459 49.6645 33.7173 49.9747 34.0256C50.2849 34.334 50.4228 34.711 50.4228 35.1907C50.4228 35.6704 50.2849 36.0816 49.9747 36.39Z",
    fill: "#D6D6D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44498 29.8452H0V37.5377V41.4954L3.10188 45.2303H3.2225H6.44498C8.78866 45.2303 10.7187 44.5107 12.2696 43.0373C13.8206 41.5297 14.6133 39.7136 14.6133 37.5548C14.6133 35.3961 13.8206 33.5801 12.2696 32.1067C10.7187 30.5647 8.78866 29.8452 6.44498 29.8452ZM9.23667 40.3646C8.47847 41.1185 7.54789 41.4954 6.44498 41.4954H4.0669V33.5801H6.44498C7.54789 33.5801 8.47847 33.957 9.23667 34.7108C9.99492 35.4647 10.374 36.3898 10.374 37.5206C10.374 38.6171 9.99492 39.5765 9.23667 40.3646Z",
    fill: "#D6D6D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2073 0L71.3434 4.79715V79.4958L67.2073 74.6986V0ZM36.2669 36.2062C36.2151 36.9592 36.1887 37.7192 36.1887 38.4852C36.1887 39.2513 36.2151 40.0113 36.2669 40.7642V36.2062ZM38.6902 25.9154H43.3076C46.4991 19.4106 52.0904 14.2832 58.9357 11.6724V55.8526L63.0718 60.6496V7.19572V6.16772C52.0073 8.25437 42.8931 15.8183 38.6902 25.9154ZM99.8603 25.9154H95.2431C92.0517 19.4106 86.4604 14.2832 79.615 11.6724V52.4261L75.4789 47.6289V10.4413V8.56637V6.16772C86.5437 8.25437 95.6574 15.8183 99.8603 25.9154Z",
    fill: "url(#paint0_radial_433_46517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_433_46517",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.2756 39.7479) rotate(90) scale(47.2863 32.643)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBB24"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepMinelogo);
export default __webpack_public_path__ + "static/media/deepMinelogo.e624b0c770dfc9eb7108b738488afd74.svg";
export { ForwardRef as ReactComponent };